export default __webpack_public_path__ + "static/4-final-score-6634032724f8bd2964d5267dd8681a3a.jpg";